// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoNote } from './po-note';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoNoteType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(15) key */
  id!: string;
  /** String(1) */
  isSystemGenerated!: string;
  /** String(50) */
  name!: string;
  /** Inv FK poNoteTypeId */
  poNotes!: PoNote[];
}

